<template>
    <div class="cps-main-page">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>渠道号绑定管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增渠道号绑定</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
        <div class="main-border">
          <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="管理员ID" prop="adminId">
              <el-input v-model="form.adminId" size="small" placeholder="请输入管理员ID"></el-input>
            </el-form-item>
            <el-form-item label="渠道号" prop="channelCode">
              <el-input v-model="form.channelCode" size="small" placeholder="请输入渠道号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button @click="back">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
    </div>
</template>

<script>
  import { addThirdpartyChannel } from '@/api/request'
  export default {
    name:'thirdChannelAdd',
    data() {
      return {
        form: {
          channelCode: '',
          adminId: ''
        },
        rules: {
          channelCode: [
            { required: true, message: '请输入渠道号',trigger: 'blur'}
          ],
          adminId: [
            { required: true, message: '请输入管理员ID', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let params = {
              channel_code: this.form.channelCode,
              admin_id: this.form.adminId
            }
            addThirdpartyChannel(params).then(res => {
              if (res.data.success){
                this.$message.success('渠道号绑定成功');
                this.$refs['form'].resetFields();
              }
              else {
                this.$message.error(res.data.error.message);
              }
            });
          } else {
            return false;
          }
        });
      },
      back() {
        this.$router.push({path: '/thirdChannelList'});
      }
    }
  }
</script>

<style scoped>
  .el-input {
    width: 250px !important;
  }
  /deep/.el-input__inner {
    border-radius: 2px !important;
    border: 1px solid #aaaaac !important;
  }
  .el-button{
    font-weight: 700;
    width: 80px;
  }
  /deep/.el-form-item__label{
    font-weight: 600;
    font-size: 13px;
  }
</style>
